
import { connect } from 'react-redux'
import PaymentCard from '../components/PaymentCard'
import { paymentHistory } from '../actions'

const mapStateToProps = (state, ownProps) => {
  return ({
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
		fetch: () => {
      return dispatch(paymentHistory())
		}
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentCard)


// WEBPACK FOOTER //
// ./src/Pages/Settings/containers/PaymentCard.js